import { DataValidator, IsBoolean, Required, transformKeys } from "@/utils/type-vaildator";
import api from "./api"; 

interface VoiceRenameResponse {
  isUsed: boolean,
}

class VoiceRenameData {
  @Required("isDuplicate cannot be empty")
  @IsBoolean("isDuplicate must be a boolean")
  isUsed: boolean;
}

const transformAndValidateData = (
  response: VoiceRenameResponse
): VoiceRenameData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, VoiceRenameData);
  } catch (error) {
    console.error("Actor rename list data validation failed:", error.message);
    throw error;
  }
};

// 定制化音频删除
export const voiceDelete = async (id: string) => {
  const res = await api.post<VoiceRenameResponse>("/audio/delete-template", { id });
  return transformAndValidateData(res.data);
};
